import { __ } from '@wordpress/i18n';
import { TextControl } from '@wordpress/components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import JoditEditor from 'jodit-react';
import { applyFilters } from '@wordpress/hooks';

import * as Controls from '../../../controls';
const { AIContent, ColorControl } = Controls;

const About = ({
    section,
    index,
    handleDateChange,
    handleChangeSectionField,
    editor,
    setAttributes,
    attributes = {},
}) => {
    const aboutDescColor = attributes?.aboutDescColor ?? '';
    const DateOfBirthColor = attributes?.DateOfBirthColor ?? '';
    const nationalityColor = attributes?.nationalityColor ?? '';
    // const style = attributes.style ?? '';
    const { style } = attributes;

    return (
        <>
            <JoditEditor
                ref={editor}
                value={section.description || ''}
                onChange={(newContent) =>
                    handleChangeSectionField(newContent, index, 'description')
                }
            />
            <AIContent 
                handleChangeSectionField={handleChangeSectionField}
                index={index}
            />  
            
            {(style !== 'style26' && style !== 'style27' && style !== 'style28') && (          
            <ColorControl
                label={__(
                'About Description Color',
                'cv-builder'
                )}
                color={aboutDescColor}
                colorName="aboutDescColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            )}
            <div className="birthdate-wrap">
                {section.nationality !== undefined && (
                    <div className="datepicker-wrap">
                        <label>{__('Date of Birth', 'cv-builder')}</label>
                        <DatePicker
                            selected={
                                section.dateOfBirth
                                    ? new Date(section.dateOfBirth)
                                    : null
                            }
                            onChange={(date) => handleDateChange(date, index)}
                            dateFormat="dd-MM-yyyy"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            isClearable
                            placeholderText={__(
                                'Select Date of Birth',
                                'cv-builder'
                            )}
                        />
                    </div>
                )}
                {section.nationality !== undefined && (
                    <TextControl
                        label={__('Nationality', 'cv-builder')}
                        value={section.nationality || ''}
                        onChange={(value) =>
                            handleChangeSectionField(value, index, 'nationality')
                        }
                    />
                )}
            </div>
            {(style !== 'style26' && style !== 'style27' && style !== 'style28') && (    
                <>      
            <ColorControl
                label={__(
                'Date of Birth Color',
                'cv-builder'
                )}
                color={DateOfBirthColor}
                colorName="DateOfBirthColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Nationality Color',
                'cv-builder'
                )}
                color={nationalityColor}
                colorName="nationalityColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            </>
            )}
        </>
    );
};

export default About;